import BookingsListPage from '../../shared/booking/BookingsListPage';

export default function FlightBookings() {
  return <BookingsListPage module="flights" title="My flight bookings" />;
}
